
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'

import { formatDate } from '@/plugin/format.js'
import { compress } from '@/plugin/imagecompress.js'
import PictureList from '@/components/PictureList.vue'
export default {
name: 'home',
data() {
return {
filters: {
registed: 0,
keyword: '',
state: ''
},
devicesdata: [],
fileList: [],
checkNum: 0,
checkAllFlag: false,
menusVisible: false,
uploaderVisible: false,
detailVisible: false,
pdateVisible: false,
alertVisible: false,
pictureVisible: false,
selections: [],
registList: [],
canregistList: [],
canUploadList: [],
canDeleteUploadList: [],
canDeleteList: [],

picturelist: [],
uploadpicturelist: [],
pictureidlist: [],
fileData: [],
uploadIdData: [],
uploadFolderIdData: [],
pdatealert: '',
dataForm: {
model: '',
seriesno: '',
pdate: null
},
alertForm: {
usercompany: 1,
companyname: '',
pdate: null
},
ucoptions: [
{
key: 1,
value: '个人用户'
},
{
key: 2,
value: '单位用户'
}
],
options: {
getThumbBoundsFn(index) {
let thumbnail = document.querySelectorAll('.previewer-img')[index]
let pageYScroll =
window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
}
}
},
filters: {
formatDate(time) {
if (time === null) {
return null
} else {
var date = new Date(time)
return formatDate(date, 'yyyy-MM-dd')
}
}
},
watch: {

checkAllFlag(flag) {
var that = this
this.devicesdata.forEach(function(item, index) {
that.$set(item, 'checked', that.checkAllFlag)
item.checked = that.checkAllFlag
})
that.selectionChange()
}
},
methods: {
getlist: function() {
let un = sessionStorage.getItem('user')
let params = {
UserName: un,
Keyword: this.filters.keyword.trim()
}
if (this.filters.registed === 1) {
params.State = '已注册'
} else {
if (!this.filters.state) {
params.State = '可注册,未通过,待审核'
} else {
params.State = this.filters.state
}
}
let that = this
this.$api
.getDevice(params)
.then(res => {
if (res.Status === 1) {
var list = []
res.Entity.forEach(dev => {
if (dev.State === '未通过') dev.StateId = 1
if (dev.State === '可注册') dev.StateId = 2
if (dev.State === '待审核') dev.StateId = 3
list.push(dev)
})
list.sort((a, b) => a.StateId - b.StateId)
that.devicesdata = list
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
},

handleEdit: function(dev) {
this.pdateVisible = true
this.dataForm = {
id: dev.Id,
model: dev.Model,
seriesno: dev.SeriesNO
}
this.pdatealert = '机型，系列号无法修改，如录入错误请删除记录后重新输入'
this.dataForm.pdate = formatDate(new Date(dev.PDate), 'yyyy-MM-dd')
},
handleOpen: function(dev) {
this.detailVisible = true
this.dataForm = dev
if (dev.PDate !== null) {
this.dataForm.PDate = formatDate(new Date(dev.PDate), 'yyyy-MM-dd')
}
},
handleConfirm: function() {
let that = this
this.$vux.confirm.show({
title: '提示',
content: '确认提交吗？',
onConfirm() {
let un = sessionStorage.getItem('user')
let params = {
UserName: un,
Model: that.dataForm.model,
SeriesNO: that.dataForm.seriesno,
PDate: that.dataForm.pdate
}
if (that.dataForm.id !== '') params.Id = that.dataForm.id
that.$api
.deviceConfirm(params)
.then(res => {
if (res.Status === 1) {
that.$vux.alert.show({
title: '提示',
content: '提交成功'
})
that.pdateVisible = false
that.getlist()
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
})
},
handleRegistList: function() {
let that = this
this.$vux.confirm.show({
title: '提示',
content: '确认注册' + this.registList.length.toString() + '台设备吗？',
onConfirm() {
that.alertForm.usercompany = 1
that.alertForm.companyname = ''
that.alertForm.pdate = null
that.canregistList = []
that.registList.forEach(dev => {
that.canregistList.push(dev)
})
that.alertVisible = true
}
})
},
handleRegist: function(device) {
this.alertForm.usercompany = 1
this.alertForm.companyname = ''
this.alertForm.pdate = null
this.canregistList = []
this.canregistList.push(device)
this.alertVisible = true
},
editRegist: function() {
let un = sessionStorage.getItem('user')
var params = []
this.canregistList.forEach(dev => {
params.push({
UserName: un,
Model: dev.Model,
SeriesNO: dev.SeriesNO,
UserCompany:
this.alertForm.usercompany === 1
? '个人'
: this.alertForm.usercompany,
PDate: this.alertForm.pdate
})
})
let that = this
this.$api
.deviceRegist(params)
.then(res => {
if (res.Status === 1) {
that.$vux.alert.show({
content: '设备注册成功',
title: '提示'
})

that.getlist()
that.alertVisible = false
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message.replace(/\n\r/g, '</br>')
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
},
handleDelete: function(device) {
this.canDeleteList = []
this.canDeleteList.push(device)
this.handleDeleteList()
},
handleDeleteList: function() {
let that = this
this.$vux.confirm.show({
title: '提示',
content:
'确认删除' +
this.canDeleteList.length.toString() +
'台设备进行保修注册吗？',
onConfirm() {
let un = sessionStorage.getItem('user')
var params = []
that.canDeleteList.forEach(dev => {
params.push({
UserName: un,
Model: dev.Model,
SeriesNO: dev.SeriesNO
})
})
that.$api
.deviceUnRegist(params)
.then(res => {
if (res.Status === 1) {
that.$vux.alert.show({
content: '设备删除成功',
title: '提示'
})
that.getlist()
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message.replace(/\n\r/g, '</br>')
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
})
},
handleScanBarcode: function(params) {
compress.compressAccurately(params.file, 1024).then(res => {
let uploadData = new FormData()
uploadData.append('file', res)
this.$api
.scanBarcode(uploadData)
.then(res => {
if (res.Status === 1) {
let un = sessionStorage.getItem('user')
let params = {
UserName: un,
Model: res.Entity['型号'].trim(),
SeriesNO: res.Entity['系列号'].trim()
}
this.pdateVisible = true
this.pdatealert = ''
this.dataForm = {
model: params.Model,
seriesno: params.SeriesNO
}
/* this.$api.deviceConfirm(params).then(res => {
if (res.Status === 1) {
this.$vux.alert.show({
title: '提示',
content: params.Model + ' ' + params.SeriesNO + '提交成功！'
})

this.getlist()
} else {
this.$vux.alert.show({
title: '错误',
content: params.Model + ' ' + params.SeriesNO + ' ' + res.Message
})
}
}) */
} else {
this.$vux.alert.show({
title: '错误',
content: res.Message
})
}
params.onSuccess()
})
.catch(function(res) {
params.onError()
})
})
},
handleUploadList: function() {
let that = this
this.$vux.confirm.show({
title: '提示',
content:
'确认上传' +
that.canUploadList.length.toString() +
'台设备的购买凭证吗？',
onConfirm() {
if (that.$refs.uploadfile !== undefined) {
that.$refs.uploadfile.clearFiles()
}

that.canUploadList.forEach(dev => {
that.uploadIdData.push(dev.Id)
})
that.uploaderVisible = true
}
})
},
handleUpload: function(device) {
if (device !== null) {
this.uploadIdData = []
this.uploadFolderIdData = []
this.uploadpicturelist = []
this.uploadIdData.push(device.Id)

if (device.PCertificate === null) {
this.uploaderVisible = true
} else {

let un = sessionStorage.getItem('user')
let params = {
UserName: un,
PCertificate: device.PCertificate
}
let that = this
this.$api
.getDevice(params)
.then(res => {
if (res.Status === 1) {
let canupload = true
res.Entity.forEach(dev => {
if (dev.State === '待审核' || dev.State === '已注册') {
canupload = false

that.$vux.alert.show({
title: '错误',
content:
'同批次凭证设备 ' +
dev.SeriesNO +
' 已提交注册，无法修改凭证，只能删除凭证!'
})
return false
}
})
if (canupload) {
that.uploadFolderIdData.push(device.PCertificate)
that.$api
.getFile(device.PCertificate)
.then(res => {
if (res.Status === 1) {
var list = []
res.Entity.forEach(item => {
list.push({
name: item.FileName,
url: 'data:image/png;base64,' + item.Contents,
Id: item.Id
})
})
that.uploadpicturelist = list
that.uploaderVisible = true
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
}
},
changeUploadFile: function(file, fileList) {
this.fileData = []
this.pictureidlist = []
fileList.forEach(file => {
if (file.Id !== undefined) {
this.pictureidlist.push(file.Id)
} else {
let isLt2M = file.raw.size / 1024 < 512 
if (isLt2M) {
this.fileData.push(file.raw)
} else {
compress.compressAccurately(file.raw, 512).then(res => {
this.fileData.push(res)
})
}
}
})
},
submitUploadFile: function() {
let fromData = new FormData()
this.uploadIdData.forEach(id => {
fromData.append('Id', id)
})
this.fileData.forEach(file => {
fromData.append('files', file)
})
this.uploadFolderIdData.forEach(id => {
fromData.append('FolderId', id)
})
this.pictureidlist.forEach(id => {
fromData.append('FileId', id)
})

let that = this
this.$api
.uploadCertificateFile(fromData)
.then(res => {
if (res.Status === 1) {
that.$vux.alert.show({
title: '提示',
content: '购买凭证提交成功'
})
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
that.uploaderVisible = false
that.getlist()
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
},
handleShowPicture: function(params) {
this.pictureVisible = true

let that = this
this.$api
.getFile(params)
.then(res => {
if (res.Status === 1) {
var list = []
res.Entity.forEach(item => {
list.push({
src: 'data:image/png;base64,' + item.Contents,
msrc: 'data:image/png;base64,' + item.Contents
})
})
that.picturelist = list
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
},
handleDeletePCertificate: function(device) {
this.canDeleteUploadList = []
this.canDeleteUploadList.push(device)
this.handleDeletePCertificateList()
},
handleDeletePCertificateList: function() {
var that = this
this.$vux.confirm.show({
title: '提示',
content:
'确认删除' +
this.canDeleteUploadList.length.toString() +
'台设备的购买凭证吗？',
onConfirm() {
let un = sessionStorage.getItem('user')
var params = []
that.canDeleteUploadList.forEach(dev => {
params.push({
UserName: un,
Model: dev.Model,
SeriesNO: dev.SeriesNO,
PCertificate: dev.PCertificate
})
})
that.$api
.deviceCancelPCertificate(params)
.then(res => {
if (res.Status === 1) {
that.$vux.alert.show({
title: '提示',
content: '设备删除购买凭证成功'
})
that.getlist()
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message.replace(/\n\r/g, '</br>')
})
}
})
.catch(function(res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
})
},
checkItem: function(item, index) {

var flag = false
if (!item.checked) {
flag = true
}

if (flag) {
this.$set(item, 'checked', false)
} else {
this.$set(item, 'checked', true)
}
this.selectionChange()
},
selectionChange: function() {
var selections = []
this.devicesdata.forEach(dev => {
if (dev.checked) {
selections.push(dev)
}
})
this.selections = selections
this.registList = []
this.canUploadList = []
this.canDeleteList = []
this.canDeleteUploadList = []
this.selections.forEach(dev => {
if (dev.State === '可注册' || dev.State === '未通过') {
this.registList.push(dev)
}
if (
dev.IsUpload &&
(dev.State === '可注册' || dev.State === '未通过')
) {
this.canUploadList.push(dev)
}
if (
dev.IsUpload &&
dev.PCertificate !== null &&
(dev.State === '可注册' || dev.State === '未通过')
) {
this.canDeleteUploadList.push(dev)
}
if (dev.State === '可注册' || dev.State === '未通过') {
this.canDeleteList.push(dev)
}
})
},
show(index) {
this.$refs.previewer.show(index)
},
logout: function() {
var that = this
this.$vux.confirm.show({
title: '提示',
content: '确认退出?',
onConfirm() {
sessionStorage.removeItem('user')
that.$router.push('/mobile/login')
}
})
},
handlePreview: function() {},
handleRemove: function() {}
},
created() {
window.document.title = '保修注册'
this.getlist()
},
directives: {
TransferDom
},
components: {
Group,
Flexbox,
FlexboxItem,
XButton,
Divider,
XHeader,
Scroller,
CheckIcon,
Popup,
Datetime,
Confirm,
Cell,
XInput,
Radio,
PictureList,
Previewer,
ButtonTab,
Search,
ButtonTabItem
}
}



// WEBPACK FOOTER //
// ./src/mobile/home.vue